import { render, staticRenderFns } from "./detailAffiliateWithdrawal.vue?vue&type=template&id=08a8fd60&scoped=true"
import script from "./detailAffiliateWithdrawal.vue?vue&type=script&lang=js"
export * from "./detailAffiliateWithdrawal.vue?vue&type=script&lang=js"
import style0 from "./detailAffiliateWithdrawal.vue?vue&type=style&index=0&id=08a8fd60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a8fd60",
  null
  
)

export default component.exports